import queryString from 'query-string';

export function parseQueryString(searchingParam, search) {
  return queryString.parse(search)[searchingParam];
}
